import { createContext, useState } from "react";

const PageContext = createContext(1);
const PageDispatchContext = createContext((value) => {});

const PageProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  return (
    <PageContext.Provider value={page}>
      <PageDispatchContext.Provider value={setPage}>
        {children}
      </PageDispatchContext.Provider>
    </PageContext.Provider>
  );
};

export { PageProvider, PageContext, PageDispatchContext };
